/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MakeBuyoutRights } from './makeBuyoutRights';
import { NoMergeData } from './noMergeData';


export interface MakeBuyoutBulkEditDto { 
    mergedData: Array<MakeBuyoutRights>;
    noMergeData: Array<NoMergeData>;
    assetsWithoutBuyoutRights?: number;
    mergedNotes?: string;
}

